import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../user/user-subscription";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import * as fromStore from "../../../store";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../store";
import {Subject} from "rxjs";
import {combineLatest} from "rxjs";
import {User} from "../../../user/user";

@Component({
    selector: 'db-informative-banner',
    templateUrl: './informative-banner-feature.component.html',
    styleUrls: ['./informative-banner-feature.component.scss'],
    standalone: false
})
export class InformativeBannerFeatureComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() description: string;
  @Input() demoUser: boolean = false;
  @Output() btnClicked: EventEmitter<void>;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public subscription: UserSubscription;
  public user: User;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.btnClicked = new EventEmitter<void>();
  }

  ngOnInit() {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription)
          )
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.subscription = userSubscription;
      });
  }

  public onBtnClick(): void {
    this.btnClicked.emit();
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
